export default "__VITE_ASSET__CaqIXMfL__"